'use client';

import { useState } from 'react';
import { ChatContact } from '../../types/chat';
import { ContactItem } from '../atoms/ContactItem';

interface ContactListProps {
  contacts: ChatContact[];
  onContactSelect: (contactId: number) => void;
}

export function ContactList({ contacts, onContactSelect }: ContactListProps) {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredContacts = contacts.filter(contact =>
    contact.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const sortedContacts = filteredContacts.sort((a, b) => {
    // Sort by unread count first, then by last message time
    if (a.unreadCount !== b.unreadCount) {
      return b.unreadCount - a.unreadCount;
    }

    if (!a.lastMessageTime && !b.lastMessageTime) return 0;
    if (!a.lastMessageTime) return 1;
    if (!b.lastMessageTime) return -1;

    return b.lastMessageTime.getTime() - a.lastMessageTime.getTime();
  });

  return (
    <div className="flex flex-col h-full">
      {/* Search bar */}
      <div className="p-4 border-b border-[#DEE2E7]">
        <div className="relative">
          <input
            type="text"
            placeholder="이름 검색"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-4 py-2 border border-[#DEE2E7] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2563EB] focus:border-transparent transition-colors duration-200"
          />
          {/* Search icon */}
          <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="11"
                cy="11"
                r="8"
                stroke="#ACB3BE"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M21 21L16.65 16.65"
                stroke="#ACB3BE"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>

      {/* Contact list */}
      <div className="flex-1 overflow-y-auto">
        {sortedContacts.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-full text-center p-8">
            <p className="text-[#6D717D] text-sm">
              {searchTerm ? '검색 결과가 없습니다' : '대화가 없습니다'}
            </p>
          </div>
        ) : (
          <div>
            {sortedContacts.map((contact) => (
              <ContactItem
                key={contact.id}
                contact={contact}
                onClick={() => onContactSelect(contact.id)}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}